import React, { useEffect, useState } from "react";
import DonutChart from "./DonutChart ";
import useRoi from "../../Context/RoiContex";
// import increaseRevenueIcon from "./../../../assets/increase_revenue.svg";
import increaseRevenueIcon from "./../../assets/increase_revenue_icon_black.svg";
import hoursRevenueIcon from "./../../assets/sand_timer_icon_black.svg";
import { NumericFormat } from "react-number-format";

function ChartContainer() {
  const {
    staffData,
    automatedSavings,
    noShowData,
    paymentCollectionData,
    numberOfProviders,
    monthlyAppointments,
    paperBasedIntakeDependency,
    percentageOfNewPatientsVisitMonth,
  } = useRoi();

  const [dataArray, setDataArray] = useState([]);

  const [annualCost, setAnnualCost] = useState(0);
  const [totalHours, setTotalHours] = useState(0);

  useEffect(() => {
    setDataArray([
      staffData.annualCostSavings,
      noShowData.averageAdditionalRevenueInYear,
      paymentCollectionData.annualIncrease,
      automatedSavings.annualCostSavings,
    ]);
    setAnnualCost(
      staffData.annualCostSavings +
        noShowData.averageAdditionalRevenueInYear +
        paymentCollectionData.annualIncrease +
        automatedSavings.annualCostSavings
    );
    setTotalHours(
      staffData.monthlyTimeSavingInHours * 12 +
        automatedSavings.monthlyHoursSavedFromVerification * 12
    );
  }, [
    staffData,
    automatedSavings,
    noShowData,
    paymentCollectionData,
    numberOfProviders,
    monthlyAppointments,
    paperBasedIntakeDependency,
    percentageOfNewPatientsVisitMonth,
  ]);

  const hasAllValues = dataArray.some((value) => value !== 0);

  // const divStyle = {
  //   background: "#FAF9F7",
  //   position: "sticky",
  //   top: "80px",
  // };

  return (
    <div className=" h-[600px]  w-full ">
      <h2 className="flex justify-center font-bold text-[32px] my-4 total-investment">
        Here’s Your Total Return on Investment
      </h2>
      <div className="flex  justify-evenly w-full your-annual-savings-container">
        <div className="flex flex-col gap-5 your-annual-savings">
          <p className="text-4xl text-[#147D6E] text-center font-bold">Your Annual Savings</p>
          <div className="flex gap-5 annual-savings">
            <div className="flex items-center  gap-2">
              <img src={increaseRevenueIcon} alt="image" className="increaseRevenueIcon" />
              <p className="text-[#71B254] font-medium paragraph-responsive-text">
                <span>
                  {/* {annualCost.toLocaleString("en-IN", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })} */}
                  <NumericFormat
                    displayType="text"
                    value={annualCost}
                    thousandSeparator={true}
                    decimalScale={0}
                    prefix={"$ "}
                  />
                </span>
              </p>
            </div>

            <div className="flex items-center  gap-2">
              <img src={hoursRevenueIcon} alt="image" className="increaseRevenueIcon" />
              <p className="text-[#71B254] font-medium paragraph-responsive-text">
                {totalHours.toLocaleString("en-US", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}{" "}
                Hours{" "}
              </p>
            </div>
          </div>
        </div>
        {dataArray.length > 0 && hasAllValues && <DonutChart dataArray={dataArray} />}
      </div>
    </div>
  );
}

export default ChartContainer;
